import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const CenteredTemplateOneOneFive = ({
  titleText = "ONE OF\nA KIND",
  titleFont = "Helvetica",
  titleFontSize = "72",
  titleColor = "#E6E7EB",
  titleTextAlign = "center",
  titleIsBold = true,
  titleIsItalic = false,
  titleIsUnderline = false,
  titleUppercase = false,

  subtitleText = "Two reasons to buy it",
  subtitleFont = "Helvetica",
  subtitleFontSize = "20",
  subtitleColor = "#FFFFFF",
  subtitleTextAlign = "center",
  subtitleIsBold = false,
  subtitleIsItalic = false,
  subtitleIsUnderline = false,

  backgroundType = "color",
  backgroundColor = "#0B0F14",
  backgroundImage = null,

  buttonLabel = "More Info",
  buttonFont = "Helvetica",
  buttonIsBold = true,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "18",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#C03BFF",

  // Images
  contentImageTop = "/oneoneFiveCar.png",
  contentImageBottom = "/oneoneFiveBottom.png",

  backgroundImagePreview,

  preview = false,
  inmeeting = false,
  center = false,
  onClose,
}) => {
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();

  return (
    <div
    className={`relative ${
      !inmeeting ? "h-auto min-h-[283px]" : center ? "!h-[50vh]" : "!h-[15vh]"
    } w-full flex flex-col mx-auto items-center justify-between  overflow-hidden`}
      style={{ backgroundColor: "#000" }}
    >
      {/* Close Button */}
      {inmeeting && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}

      {/* Layout: images left (stacked), panel right */}
      <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 w-full max-w-5xl">
        {/* Left side images */}
        <div className="grid grid-rows-2">
          <div
            className="w-full rounded-sm min-h-[100px] md:min-h-[150px]"
            style={{
              backgroundImage: `url(${contentImageTop})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />
          <div
            className="w-full rounded-sm min-h-[100px] md:min-h-[150px]"
            style={{
              backgroundImage: `url(${contentImageBottom})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />
        </div>

        {/* Right panel */}
        <div
          className="w-full rounded-sm flex flex-col items-center justify-center gap-5 md:gap-8 px-2"
          style={{ backgroundColor }}
        >
          <h1
            className={`whitespace-pre-line text-center ${
              explicitBoleanCheck(titleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(titleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(titleIsUnderline) ? "underline" : ""
            } ${titleUppercase ? "uppercase" : ""}`}
            style={{
              color: titleColor,
              fontSize: `${titleFontSize}px`,
              fontFamily: titleFont,
              textAlign: titleTextAlign,
              lineHeight: "1.05",
              whiteSpace: "pre-line",
            }}
          >
            {titleText}
          </h1>

          <div
            className={`text-center ${
              explicitBoleanCheck(subtitleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(subtitleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(subtitleIsUnderline) ? "underline" : ""
            }`}
            style={{
              color: subtitleColor,
              fontSize: `${subtitleFontSize}px`,
              fontFamily: subtitleFont,
              textAlign: subtitleTextAlign,
              opacity: 0.95,
            }}
          >
            {subtitleText}
          </div>

          <button
            className={`px-10 md:px-12 py-3 md:py-4 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl ${
              buttonLink ? "cursor-pointer" : "cursor-default"
            }`}
            style={{
              backgroundImage:
                "linear-gradient(90deg, #FF4FD8 0%, #8B5CF6 100%)",
              color: buttonFontColor,
              fontSize: `${buttonFontSize}px`,
              fontFamily: buttonFont,
              fontWeight: explicitBoleanCheck(buttonIsBold) ? "bold" : "normal",
              fontStyle: explicitBoleanCheck(buttonIsItalic) ? "italic" : "normal",
              textDecoration: explicitBoleanCheck(buttonIsUnderline) ? "underline" : "none",
              borderRadius: "9999px",
            }}
            onClick={() => {
              if (buttonLink) {
                window.open(buttonLink, "_blank");
              }
            }}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CenteredTemplateOneOneFive;


